import Meetings from '@/services/Meetings';

export default {
  setSelectedDay: ({ commit }, day) => commit('SET_SELECTED_DAY', day),

  fetchAvailableTimes: ({ commit }, moment) => {
    Meetings.fetchAvailableTimes(moment).then(response => {
      commit('SET_AVAILABLE_TIMES', response.data);
    });
  },

  setActivedWeekIndex: ({ commit }, index) =>
    commit('SET_ACTIVED_WEEK_INDEX', index),
};
